module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-3-large-c7eca640f8536d875bdbcda79159f33c.jpg";